/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type createPictureMutationVariables = {|
  id: string
|};
export type createPictureMutationResponse = {|
  +recipeMediaCreate: ?{|
    +recipeMedia: ?{|
      +id: string,
      +file: string,
    |}
  |}
|};
export type createPictureMutation = {|
  variables: createPictureMutationVariables,
  response: createPictureMutationResponse,
|};
*/


/*
mutation createPictureMutation(
  $id: ID!
) {
  recipeMediaCreate(input: {recipe: $id}) {
    recipeMedia {
      id
      file
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "recipe",
            "variableName": "id"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "RecipeMediaCreatePayload",
    "kind": "LinkedField",
    "name": "recipeMediaCreate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecipeMediaNode",
        "kind": "LinkedField",
        "name": "recipeMedia",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "file",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createPictureMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createPictureMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "createPictureMutation",
    "operationKind": "mutation",
    "text": "mutation createPictureMutation(\n  $id: ID!\n) {\n  recipeMediaCreate(input: {recipe: $id}) {\n    recipeMedia {\n      id\n      file\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e5396ea65486e243a5e5f817ca2ee44b';

module.exports = node;
